module.exports = __webpack_public_path__ + "img/party_upper_1.1d99b7d1.jpg";